(function () {
  'use strict';

  const STORAGE_KEY = 'gymaths_wishlist_v1';

  function getWishlist() {
    try {
      const saved = JSON.parse(
        localStorage.getItem(STORAGE_KEY) || '[]'
      );

      return Array.isArray(saved)
        ? [...new Set(saved.filter(Boolean))]
        : [];
    } catch (error) {
      return [];
    }
  }

  function saveWishlist(items) {
    const cleanItems = [...new Set(items.filter(Boolean))];

    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(cleanItems)
      );
    } catch (error) {
      console.warn('Gymaths wishlist could not be saved.');
    }

    updateCount();

    window.dispatchEvent(
      new CustomEvent('gymaths:wishlist-updated', {
        detail: {
          handles: cleanItems,
          count: cleanItems.length
        }
      })
    );

    return cleanItems;
  }

  function contains(handle) {
    return getWishlist().includes(handle);
  }

  function add(handle) {
    if (!handle) return;

    const items = getWishlist();

    if (!items.includes(handle)) {
      items.push(handle);
    }

    saveWishlist(items);
  }

  function remove(handle) {
    if (!handle) return;

    saveWishlist(
      getWishlist().filter(function (item) {
        return item !== handle;
      })
    );
  }

  function toggle(handle) {
    if (!handle) return;

    if (contains(handle)) {
      remove(handle);
    } else {
      add(handle);
    }
  }

  function updateCount() {
    const count = getWishlist().length;

    document
      .querySelectorAll('.gymaths-wishlist-count')
      .forEach(function (badge) {
        badge.textContent = count;

        if (count > 0) {
          badge.removeAttribute('hidden');
        } else {
          badge.setAttribute('hidden', '');
        }
      });
  }

  function syncButton(button) {
    if (!button) return;

    const handle = button.dataset.productHandle;

    if (!handle) return;

    const active = contains(handle);

    button.classList.toggle('is-active', active);

    button.setAttribute(
      'aria-pressed',
      active ? 'true' : 'false'
    );

    button.setAttribute(
      'aria-label',
      active
        ? 'Remove from Wishlist'
        : 'Add to Wishlist'
    );
  }

  function syncAllButtons() {
    document
      .querySelectorAll(
        '.gymaths-wishlist-btn[data-product-handle]'
      )
      .forEach(syncButton);

    updateCount();
  }

  window.GymathsWishlist = {
    get: getWishlist,
    has: contains,
    add: add,
    remove: remove,
    toggle: toggle,
    sync: syncAllButtons
  };

  /*
   * Wishlist heart clicks
   */
  document.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest(
        '.gymaths-wishlist-btn[data-product-handle]'
      );

      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      const handle = button.dataset.productHandle;

      if (!handle) return;

      toggle(handle);
      syncButton(button);
    },
    true
  );

  /*
   * Initial page load
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      syncAllButtons
    );
  } else {
    syncAllButtons();
  }

  /*
   * Shopify theme editor section reload
   */
  document.addEventListener(
    'shopify:section:load',
    function () {
      syncAllButtons();
    }
  );

  /*
   * Sync across browser tabs
   */
  window.addEventListener(
    'storage',
    function (event) {
      if (event.key === STORAGE_KEY) {
        syncAllButtons();
      }
    }
  );
})();